// LooksReportForm.js

import React, { useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  MenuItem
} from '@mui/material';

/* ─────────────────────────────
   Centered modal styling
   ──────────────────────────── */
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'calc(100% - 40px)',
  maxWidth: 420,
  bgcolor: '#fff',
  borderRadius: 2,
  boxShadow: 24,
  p: 3,
  maxHeight: '90vh',
  overflowY: 'auto'
};

const REPORT_REASONS = [
  'Spam',
  'Harassment / Hate',
  'Misinformation',
  'Inappropriate content',
  'Self-harm',
  'Other'
];

const LooksReportForm = ({ postId, submitReport, closeModal }) => {
  const [reason, setReason]       = useState(REPORT_REASONS[0]);
  const [details, setDetails]     = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);

    try {
      await submitReport({
        postId,
        reason,
        details,
        timestamp: new Date().toISOString(),
        type: 'post'
      });
      alert('Thank you. Your report has been submitted.');
      closeModal();
    } catch (err) {
      console.error('Error submitting report:', err);
      alert('Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal open onClose={closeModal}>
      <Box sx={modalStyle} component="form" onSubmit={handleSubmit}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          Report this Post
        </Typography>

        <TextField
          select
          fullWidth
          label="Reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          sx={{ mb: 2 }}
        >
          {REPORT_REASONS.map((r) => (
            <MenuItem key={r} value={r}>
              {r}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          multiline
          minRows={4}
          fullWidth
          label="Additional details (optional)"
          value={details}
          onChange={(e) => setDetails(e.target.value)}
          sx={{ mb: 3 }}
        />

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button onClick={closeModal} disabled={submitting}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={submitting}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default LooksReportForm;
